"use strict";

document.getElementById("contactForm").addEventListener("submit", function (e) {
  e.preventDefault(); // Prevent form submission

  var isValid = true; // Assume form is valid initially
  var form = this; // Reference to the form
  var requiredFields = form.querySelectorAll("[required]"); // Select all required fields

  // Reset previous validation styles
  requiredFields.forEach(function (field) {
    field.style.border = ""; // Remove any previous red border
  });

  // Validate required fields
  requiredFields.forEach(function (field) {
    if (!field.value.trim()) {
      field.style.border = "2px solid red"; // Apply red border to invalid fields
      isValid = false;
    }
  });
  if (!isValid) {
    // Display an error message if validation fails
    var responseMessage = document.getElementById("responseMessage");
    responseMessage.textContent = "Please fill in all required fields.";
    responseMessage.style.color = "red";
    return;
  }

  // If the form is valid, proceed with the AJAX request
  var formData = new FormData(form);
  fetch("send_request.php", {
    method: "POST",
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    var responseMessage = document.getElementById("responseMessage");
    var webForm = document.getElementById("contactForm");
    if (data.success) {
      // Hide the form
      webForm.style.display = "none";

      // Display the success message
      responseMessage.textContent = "Thank you! Your request has been sent.";
      responseMessage.style.color = "green";
      responseMessage.style.display = "block"; // Ensure the message is visible
    } else {
      // Show an error message
      responseMessage.textContent = data.error || "An error occurred.";
      responseMessage.style.color = "red";
      responseMessage.style.display = "block"; // Ensure the message is visible
    }
  })["catch"](function (error) {
    console.error("Error:", error);

    // Display a generic error message
    var responseMessage = document.getElementById("responseMessage");
    responseMessage.textContent = "An unexpected error occurred.";
    responseMessage.style.color = "red";
    responseMessage.style.display = "block"; // Ensure the message is visible
  });
});
document.addEventListener("DOMContentLoaded", function () {
  // Select all anchor links with href starting with #
  var anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent the default anchor behavior

      var targetId = this.getAttribute("href").substring(1); // Get target ID
      var targetElement = document.getElementById(targetId); // Find target element

      if (targetElement) {
        // Scroll to the target element smoothly
        var targetPosition = targetElement.offsetTop; // Element's position from the top of the page
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth"
        });
      }
    });
  });
});

// Mobile friendlier approach
// Detects mobile device to prevent mobile video from downloading, otherwise it replaces data-src with src a reloads video for desktop
var isMobile = {
  Android: function Android() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function BlackBerry() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function iOS() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function Opera() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function Windows() {
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },
  any: function any() {
    return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
  }
};

// nav menu style
var nav = $("#navbarSupportedContent");
var btn = $(".custom_menu-btn");
btn.click;
btn.click(function (e) {
  e.preventDefault();
  nav.toggleClass("lg_nav-toggle");
  document.querySelector(".custom_menu-btn").classList.toggle("menu_btn-style");
});